export class UserPermission {
    public static readonly read: string = 'usermanager:read:user';
    public static readonly readMe: string = 'usermanager:read:me';
    public static readonly update: string = 'usermanager:update:user';
    public static readonly search: string = 'usermanager:search:users';

    public static readonly updateCaseAllocation: string =
        'usermanager:update:case-allocation';
    public static readonly updateClaimAllocation: string =
        'usermanager:update:claim-allocation';

    public static readonly readFieldsOfLaw: string =
        'usermanager:read:fieldsoflaw';
    public static readonly updateFieldsOfLaw: string =
        'usermanager:update:user-fieldsoflaw';
    public static readonly readLanguages: string = 'usermanager:read:languages';
    public static readonly updateLanguages: string =
        'usermanager:update:user-languages';
    public static readonly readLeave: string = 'usermanager:read:leave';
    public static readonly updateSpecialisations: string =
        'usermanager:update:specialisations';
}
